<template>
  <div class="actions-module">
    <div class="button reset-tokens" @click="resetToken()">reset</div>

    <div v-if="guidesVisible" class="button reset-tokens" @click="showAnswer()">
      Verberg Oplossing
    </div>
    <div v-else class="button reset-tokens" @click="showAnswer()">Oplossing</div>
  </div>
</template>

<script>
  import EventBus from "../eventBus";

  export default {
    name: "Actions",

    props: {
      guidesVisible: Boolean,
    },

    methods: {
      // fire event to putt all tokens back to its original position.
      // fire alert first for confirmation.
      resetToken() {
        if (
          confirm(
            "Weet u zeker dat u het assenstelsel wilt resetten? Alle partijen zullen worden terug geplaatst."
          )
        ) {
          EventBus.$emit("resetToken");
        }
      },

      // fire event to show guides for each party
      showAnswer: function () {
        EventBus.$emit("toggleGuide");
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .actions-module {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    padding: 20px;
    user-select: none;

    .button {
      font-size: 14px;
      line-height: 1.8em;
      font-weight: $font-medium;
      color: $cerulean;
      padding: 0px 15px;
      text-transform: uppercase;

      &:hover {
        color: $flamingo;
        cursor: pointer;
      }
    }
  }
</style>
